const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? 'https://api.modurax.in' : 'http://localhost:4000');

function asStringList(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === 'string' && value.trim()) return [value.trim()];
  return [];
}

export function mediaUrl(path) {
  if (!path) return '';
  if (path.startsWith('http') || path.startsWith('blob:')) return path;
  return `${API_URL}${path}`;
}

export async function fetchProductsPage() {
  const res = await fetch(`${API_URL}/api/products-page`);
  if (!res.ok) throw new Error('Failed to load products');
  const data = await res.json();
  return {
    ...data,
    products: data.products.map((p) => ({
      ...p,
      features: asStringList(p.features),
      image: mediaUrl(p.image),
      secondaryImage: p.secondaryImage ? mediaUrl(p.secondaryImage) : undefined,
    })),
    deckingOptions: data.deckingOptions.map((d) => ({
      ...d,
      benefits: asStringList(d.benefits),
      image: mediaUrl(d.image),
    })),
    accessoriesImage: mediaUrl(data.accessoriesImage),
  };
}

export async function fetchRackingSystems() {
  const res = await fetch(`${API_URL}/api/racking-systems`);
  if (!res.ok) throw new Error('Failed to load racking systems');
  return res.json();
}

export async function fetchRackingSystem(slug) {
  const res = await fetch(`${API_URL}/api/racking-systems/${slug}`);
  if (!res.ok) throw new Error('Product not found');
  const p = await res.json();
  return {
    ...p,
    features: asStringList(p.features),
    image: mediaUrl(p.image),
    secondaryImage: p.secondaryImage ? mediaUrl(p.secondaryImage) : undefined,
  };
}

export async function submitContactForm(body) {
  const res = await fetch(`${API_URL}/api/forms/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error('Failed to submit form');
  return res.json();
}

export async function submitRequirementForm(payload) {
  const res = await fetch(`${API_URL}/api/forms/requirement`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Failed to submit form');
  return res.json();
}
